var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "m19 1-3.005 15.69s-.42 1.089-1.576.567L7.485 11.75l-.033-.016c.937-.871 8.2-7.634 8.518-7.94.491-.475.186-.758-.384-.4l-10.73 7.056L.719 9.01s-.652-.24-.714-.761c-.064-.523.735-.806.735-.806L17.613.587S19-.043 19 1.001"
  })));
};
export default SvgTelegram;